export const opIdiomaCatalogo = {
  BR: '0',
  EN: '1',
  IT: '2',
  FR: '3',
  RU: '4',
  DE: '5',
  ES: '6',
};

export const CAMPO_POR_IDIOMA = {
  [opIdiomaCatalogo.EN]: 'descricaoEN',
  [opIdiomaCatalogo.IT]: 'descricaoIT',
  [opIdiomaCatalogo.FR]: 'descricaoFR',
  [opIdiomaCatalogo.RU]: 'descricaoRU',
  [opIdiomaCatalogo.DE]: 'descricaoDE',
  [opIdiomaCatalogo.ES]: 'descricaoES',
};

export const PORTUGUESE = {
  [opIdiomaCatalogo.BR]: 'Português',
  [opIdiomaCatalogo.EN]: 'Portuguese',
  [opIdiomaCatalogo.IT]: 'Portoghese',
  [opIdiomaCatalogo.FR]: 'Portugais',
  [opIdiomaCatalogo.RU]: 'Португальский',
  [opIdiomaCatalogo.DE]: 'Portugiesisch',
  [opIdiomaCatalogo.ES]: 'Portugués',
};

export const ENGLISH = {
  [opIdiomaCatalogo.BR]: 'Inglês',
  [opIdiomaCatalogo.EN]: 'English',
  [opIdiomaCatalogo.IT]: 'Inglese',
  [opIdiomaCatalogo.FR]: 'Anglais',
  [opIdiomaCatalogo.RU]: 'Английский',
  [opIdiomaCatalogo.DE]: 'Englisch',
  [opIdiomaCatalogo.ES]: 'Inglés',
};

export const ITALIAN = {
  [opIdiomaCatalogo.BR]: 'Italiano',
  [opIdiomaCatalogo.EN]: 'Italian',
  [opIdiomaCatalogo.IT]: 'Italiano',
  [opIdiomaCatalogo.FR]: 'Italien',
  [opIdiomaCatalogo.RU]: 'Итальянский',
  [opIdiomaCatalogo.DE]: 'Italienisch',
  [opIdiomaCatalogo.ES]: 'Italiano',
};

export const FRENCH = {
  [opIdiomaCatalogo.BR]: 'Francês',
  [opIdiomaCatalogo.EN]: 'French',
  [opIdiomaCatalogo.IT]: 'Francese',
  [opIdiomaCatalogo.FR]: 'Français',
  [opIdiomaCatalogo.RU]: 'Французский',
  [opIdiomaCatalogo.DE]: 'Französisch',
  [opIdiomaCatalogo.ES]: 'Francés',
};

export const RUSSIAN = {
  [opIdiomaCatalogo.BR]: 'Russo',
  [opIdiomaCatalogo.EN]: 'Russian',
  [opIdiomaCatalogo.IT]: 'Russo',
  [opIdiomaCatalogo.FR]: 'Russe',
  [opIdiomaCatalogo.RU]: 'Русский',
  [opIdiomaCatalogo.DE]: 'Russisch',
  [opIdiomaCatalogo.ES]: 'Ruso',
};

export const GERMAN = {
  [opIdiomaCatalogo.BR]: 'Alemão',
  [opIdiomaCatalogo.EN]: 'German',
  [opIdiomaCatalogo.IT]: 'Tedesco',
  [opIdiomaCatalogo.FR]: 'Allemand',
  [opIdiomaCatalogo.RU]: 'Немецкий',
  [opIdiomaCatalogo.DE]: 'Deutsch',
  [opIdiomaCatalogo.ES]: 'Alemán',
};

export const SPANISH = {
  [opIdiomaCatalogo.BR]: 'Espanhol',
  [opIdiomaCatalogo.EN]: 'Spanish',
  [opIdiomaCatalogo.IT]: 'Spagnolo',
  [opIdiomaCatalogo.FR]: 'Espagnol',
  [opIdiomaCatalogo.RU]: 'Испанский',
  [opIdiomaCatalogo.DE]: 'Spanisch',
  [opIdiomaCatalogo.ES]: 'Español',
};

export const HEADER_TABLE_ITENS_IT = {
  [opIdiomaCatalogo.BR]: 'Item',
  [opIdiomaCatalogo.EN]: 'Item',
  [opIdiomaCatalogo.IT]: 'Articolo',
  [opIdiomaCatalogo.FR]: 'Article',
  [opIdiomaCatalogo.RU]: 'Позиция',
  [opIdiomaCatalogo.DE]: 'Artikel',
  [opIdiomaCatalogo.ES]: 'Artículo',
};

export const HEADER_TABLE_ITENS_PN = {
  [opIdiomaCatalogo.BR]: 'Partnumber',
  [opIdiomaCatalogo.EN]: 'Part Number',
  [opIdiomaCatalogo.IT]: 'Numero Parte',
  [opIdiomaCatalogo.FR]: 'Numéro de Pièce',
  [opIdiomaCatalogo.RU]: 'Номер детали',
  [opIdiomaCatalogo.DE]: 'Teilenummer',
  [opIdiomaCatalogo.ES]: 'Número de Parte',
};

export const HEADER_TABLE_ITENS_CERP = {
  [opIdiomaCatalogo.BR]: 'Código ERP',
  [opIdiomaCatalogo.EN]: 'ERP Code',
  [opIdiomaCatalogo.IT]: 'Codice ERP',
  [opIdiomaCatalogo.FR]: 'Code ERP',
  [opIdiomaCatalogo.RU]: 'Код ERP',
  [opIdiomaCatalogo.DE]: 'ERP-Code',
  [opIdiomaCatalogo.ES]: 'Código ERP',
};

export const HEADER_TABLE_ITENS_DESC = {
  [opIdiomaCatalogo.BR]: 'Descrição',
  [opIdiomaCatalogo.EN]: 'Description',
  [opIdiomaCatalogo.IT]: 'Descrizione',
  [opIdiomaCatalogo.FR]: 'Description',
  [opIdiomaCatalogo.RU]: 'Описание',
  [opIdiomaCatalogo.DE]: 'Beschreibung',
  [opIdiomaCatalogo.ES]: 'Descripción',
};

export const HEADER_TABLE_ITENS_QTD = {
  [opIdiomaCatalogo.BR]: 'Quantidade',
  [opIdiomaCatalogo.EN]: 'Quantity',
  [opIdiomaCatalogo.IT]: 'Quantità',
  [opIdiomaCatalogo.FR]: 'Quantité',
  [opIdiomaCatalogo.RU]: 'Количество',
  [opIdiomaCatalogo.DE]: 'Menge',
  [opIdiomaCatalogo.ES]: 'Cantidad',
};

export const HEADER_TABLE_ITENS_NT = {
  [opIdiomaCatalogo.BR]: 'Nota',
  [opIdiomaCatalogo.EN]: 'Note',
  [opIdiomaCatalogo.IT]: 'Nota',
  [opIdiomaCatalogo.FR]: 'Note',
  [opIdiomaCatalogo.RU]: 'Примечание',
  [opIdiomaCatalogo.DE]: 'Notiz',
  [opIdiomaCatalogo.ES]: 'Nota',
};

export const HEADER_TABLE_ITENS_ADD = {
  [opIdiomaCatalogo.BR]: 'Adicionar',
  [opIdiomaCatalogo.EN]: 'Add',
  [opIdiomaCatalogo.IT]: 'Aggiungi',
  [opIdiomaCatalogo.FR]: 'Ajouter',
  [opIdiomaCatalogo.RU]: 'Добавить',
  [opIdiomaCatalogo.DE]: 'Hinzufügen',
  [opIdiomaCatalogo.ES]: 'Agregar',
};

export const PLACEHOLDER_SEARCH = {
  [opIdiomaCatalogo.BR]: 'Digite para pesquisar',
  [opIdiomaCatalogo.EN]: 'Type to search',
  [opIdiomaCatalogo.IT]: 'Digita per cercare',
  [opIdiomaCatalogo.FR]: 'Tapez pour rechercher',
  [opIdiomaCatalogo.RU]: 'Введите для поиска',
  [opIdiomaCatalogo.DE]: 'Zum Suchen eingeben',
  [opIdiomaCatalogo.ES]: 'Escriba para buscar',
};

export const PLACEHOLDER_SEARCH_TERM_PN_ERP = {
  [opIdiomaCatalogo.BR]:
    'Digite um termo, partnumber ou código ERP para pesquisar...',
  [opIdiomaCatalogo.EN]: 'Enter a term, part number, or ERP code to search...',
  [opIdiomaCatalogo.IT]:
    'Inserisci un termine, un numero parte o un codice ERP da cercare...',
  [opIdiomaCatalogo.FR]:
    'Saisissez un terme, un numéro de pièce ou un code ERP à rechercher...',
  [opIdiomaCatalogo.RU]:
    'Введите термин, номер детали или код ERP для поиска...',
  [opIdiomaCatalogo.DE]:
    'Geben Sie einen Begriff, eine Teilenummer oder einen ERP-Code zur Suche ein...',
  [opIdiomaCatalogo.ES]:
    'Ingrese un término, número de parte o código ERP para buscar...',
};

export const SYSTEM_FACES = {
  [opIdiomaCatalogo.BR]: 'Faces do sistema',
  [opIdiomaCatalogo.EN]: 'System faces',
  [opIdiomaCatalogo.IT]: 'Facce del sistema',
  [opIdiomaCatalogo.FR]: 'Faces du système',
  [opIdiomaCatalogo.RU]: 'Грани системы',
  [opIdiomaCatalogo.DE]: 'Systemflächen',
  [opIdiomaCatalogo.ES]: 'Caras del sistema',
};

export const SYSTEM_TREE = {
  [opIdiomaCatalogo.BR]: 'Sistemas',
  [opIdiomaCatalogo.EN]: 'Systems',
  [opIdiomaCatalogo.IT]: 'Sistemi',
  [opIdiomaCatalogo.FR]: 'Systèmes',
  [opIdiomaCatalogo.RU]: 'Системы',
  [opIdiomaCatalogo.DE]: 'Systeme',
  [opIdiomaCatalogo.ES]: 'Sistemas',
};

export const HELLO = {
  [opIdiomaCatalogo.BR]: 'Olá',
  [opIdiomaCatalogo.EN]: 'Hello',
  [opIdiomaCatalogo.IT]: 'Ciao',
  [opIdiomaCatalogo.FR]: 'Bonjour',
  [opIdiomaCatalogo.RU]: 'Здравствуйте',
  [opIdiomaCatalogo.DE]: 'Hallo',
  [opIdiomaCatalogo.ES]: 'Hola',
};

export const ADD_TO_CART = {
  [opIdiomaCatalogo.BR]: 'Adicionar ao carrinho',
  [opIdiomaCatalogo.EN]: 'Add to cart',
  [opIdiomaCatalogo.IT]: 'Aggiungi al carrello',
  [opIdiomaCatalogo.FR]: 'Ajouter au panier',
  [opIdiomaCatalogo.RU]: 'Добавить в корзину',
  [opIdiomaCatalogo.DE]: 'In den Warenkorb',
  [opIdiomaCatalogo.ES]: 'Agregar al carrito',
};

export const CREATE_SET_KIT = {
  [opIdiomaCatalogo.BR]: 'Criar conjunto/kit',
  [opIdiomaCatalogo.EN]: 'Create set/kit',
  [opIdiomaCatalogo.IT]: 'Crea set/kit',
  [opIdiomaCatalogo.FR]: 'Créer ensemble/kit',
  [opIdiomaCatalogo.RU]: 'Создать набор/комплект',
  [opIdiomaCatalogo.DE]: 'Set/Kit erstellen',
  [opIdiomaCatalogo.ES]: 'Crear conjunto/kit',
};

export const SUGGESTED_KIT = {
  [opIdiomaCatalogo.BR]: 'Kit Sugerido',
  [opIdiomaCatalogo.EN]: 'Suggested Kit',
  [opIdiomaCatalogo.IT]: 'Kit suggerito',
  [opIdiomaCatalogo.FR]: 'Kit suggéré',
  [opIdiomaCatalogo.RU]: 'Рекомендуемый комплект',
  [opIdiomaCatalogo.DE]: 'Vorgeschlagenes Kit',
  [opIdiomaCatalogo.ES]: 'Kit sugerido',
};

export const MARK_ALL = {
  [opIdiomaCatalogo.BR]: 'Marcar todos',
  [opIdiomaCatalogo.EN]: 'Select all',
  [opIdiomaCatalogo.IT]: 'Seleziona tutti',
  [opIdiomaCatalogo.FR]: 'Tout sélectionner',
  [opIdiomaCatalogo.RU]: 'Выбрать все',
  [opIdiomaCatalogo.DE]: 'Alle auswählen',
  [opIdiomaCatalogo.ES]: 'Seleccionar todos',
};

export const CLEAR_ALL = {
  [opIdiomaCatalogo.BR]: 'Limpar todos',
  [opIdiomaCatalogo.EN]: 'Clear all',
  [opIdiomaCatalogo.IT]: 'Cancella tutto',
  [opIdiomaCatalogo.FR]: 'Tout effacer',
  [opIdiomaCatalogo.RU]: 'Очистить все',
  [opIdiomaCatalogo.DE]: 'Alle löschen',
  [opIdiomaCatalogo.ES]: 'Limpiar todo',
};

export const NON_ORIGINAL_MATERIALS_WARNING = {
  [opIdiomaCatalogo.BR]:
    'Atenção: Materiais não originais estão destacados na listagem',
  [opIdiomaCatalogo.EN]:
    'Attention: Non-original materials are highlighted in the list',
  [opIdiomaCatalogo.IT]:
    'Attenzione: i materiali non originali sono evidenziati nell’elenco',
  [opIdiomaCatalogo.FR]:
    'Attention : les matériaux non originaux sont mis en évidence dans la liste',
  [opIdiomaCatalogo.RU]: 'Внимание: неоригинальные материалы выделены в списке',
  [opIdiomaCatalogo.DE]:
    'Achtung: Nicht originale Materialien sind in der Liste hervorgehoben',
  [opIdiomaCatalogo.ES]:
    'Atención: Los materiales no originales están destacados en la lista',
};

export const NO_ERP_CODE_RELATED_TO_MATERIAL = {
  [opIdiomaCatalogo.BR]:
    'Nenhum Código ERP relacionado com esse material para integração',
  [opIdiomaCatalogo.EN]: 'No ERP code related to this material for integration',
  [opIdiomaCatalogo.IT]:
    'Nessun codice ERP relativo a questo materiale per l’integrazione',
  [opIdiomaCatalogo.FR]: 'Aucun code ERP lié à ce matériau pour l’intégration',
  [opIdiomaCatalogo.RU]:
    'Нет ERP-кода, связанного с этим материалом для интеграции',
  [opIdiomaCatalogo.DE]:
    'Kein ERP-Code für dieses Material zur Integration vorhanden',
  [opIdiomaCatalogo.ES]:
    'Ningún código ERP relacionado con este material para la integración',
};

export const CART = {
  [opIdiomaCatalogo.BR]: 'Carrinho',
  [opIdiomaCatalogo.EN]: 'Cart',
  [opIdiomaCatalogo.IT]: 'Carrello',
  [opIdiomaCatalogo.FR]: 'Panier',
  [opIdiomaCatalogo.RU]: 'Корзина',
  [opIdiomaCatalogo.DE]: 'Warenkorb',
  [opIdiomaCatalogo.ES]: 'Carrito',
};

export const MY_PROFILE = {
  [opIdiomaCatalogo.BR]: 'Meu Perfil',
  [opIdiomaCatalogo.EN]: 'My Profile',
  [opIdiomaCatalogo.IT]: 'Il mio profilo',
  [opIdiomaCatalogo.FR]: 'Mon profil',
  [opIdiomaCatalogo.RU]: 'Мой профиль',
  [opIdiomaCatalogo.DE]: 'Mein Profil',
  [opIdiomaCatalogo.ES]: 'Mi perfil',
};

export const MY_REQUESTS = {
  [opIdiomaCatalogo.BR]: 'Minhas Solicitações',
  [opIdiomaCatalogo.EN]: 'My Requests',
  [opIdiomaCatalogo.IT]: 'Le mie richieste',
  [opIdiomaCatalogo.FR]: 'Mes demandes',
  [opIdiomaCatalogo.RU]: 'Мои запросы',
  [opIdiomaCatalogo.DE]: 'Meine Anfragen',
  [opIdiomaCatalogo.ES]: 'Mis solicitudes',
};

export const LOGOUT = {
  [opIdiomaCatalogo.BR]: 'Sair',
  [opIdiomaCatalogo.EN]: 'Logout',
  [opIdiomaCatalogo.IT]: 'Esci',
  [opIdiomaCatalogo.FR]: 'Se déconnecter',
  [opIdiomaCatalogo.RU]: 'Выйти',
  [opIdiomaCatalogo.DE]: 'Abmelden',
  [opIdiomaCatalogo.ES]: 'Cerrar sesión',
};

export const MY_WITHDRAWALS = {
  [opIdiomaCatalogo.BR]: 'Minhas Retiradas',
  [opIdiomaCatalogo.EN]: 'My Pickups',
  [opIdiomaCatalogo.IT]: 'I miei ritiri',
  [opIdiomaCatalogo.FR]: 'Mes retraits',
  [opIdiomaCatalogo.RU]: 'Мои получения',
  [opIdiomaCatalogo.DE]: 'Meine Abholungen',
  [opIdiomaCatalogo.ES]: 'Mis retiros',
};

export const NO_ITEM_FOUND = {
  [opIdiomaCatalogo.BR]: 'Nenhum item encontrado',
  [opIdiomaCatalogo.EN]: 'No item found',
  [opIdiomaCatalogo.IT]: 'Nessun articolo trovato',
  [opIdiomaCatalogo.FR]: 'Aucun article trouvé',
  [opIdiomaCatalogo.RU]: 'Элемент не найден',
  [opIdiomaCatalogo.DE]: 'Kein Artikel gefunden',
  [opIdiomaCatalogo.ES]: 'No se encontró ningún artículo',
};

export const SELECTED_MATERIALS = {
  [opIdiomaCatalogo.BR]: 'Materiais Selecionados',
  [opIdiomaCatalogo.EN]: 'Selected Materials',
  [opIdiomaCatalogo.IT]: 'Materiali selezionati',
  [opIdiomaCatalogo.FR]: 'Matériaux sélectionnés',
  [opIdiomaCatalogo.RU]: 'Выбранные материалы',
  [opIdiomaCatalogo.DE]: 'Ausgewählte Materialien',
  [opIdiomaCatalogo.ES]: 'Materiales seleccionados',
};

export const YOUR_REQUEST = {
  [opIdiomaCatalogo.BR]: 'Sua solicitação',
  [opIdiomaCatalogo.EN]: 'Your request',
  [opIdiomaCatalogo.IT]: 'La tua richiesta',
  [opIdiomaCatalogo.FR]: 'Votre demande',
  [opIdiomaCatalogo.RU]: 'Ваша заявка',
  [opIdiomaCatalogo.DE]: 'Ihre Anfrage',
  [opIdiomaCatalogo.ES]: 'Su solicitud',
};

export const REVIEW_ITEMS_BEFORE_SUBMITTING = {
  [opIdiomaCatalogo.BR]: 'Revise os itens antes de enviar',
  [opIdiomaCatalogo.EN]: 'Review the items before submitting',
  [opIdiomaCatalogo.IT]: 'Controlla gli articoli prima di inviare',
  [opIdiomaCatalogo.FR]: 'Vérifiez les articles avant d’envoyer',
  [opIdiomaCatalogo.RU]: 'Проверьте позиции перед отправкой',
  [opIdiomaCatalogo.DE]: 'Überprüfen Sie die Artikel vor dem Senden',
  [opIdiomaCatalogo.ES]: 'Revise los artículos antes de enviar',
};

export const ITEM = {
  [opIdiomaCatalogo.BR]: 'Item',
  [opIdiomaCatalogo.EN]: 'Item',
  [opIdiomaCatalogo.IT]: 'Articolo',
  [opIdiomaCatalogo.FR]: 'Article',
  [opIdiomaCatalogo.RU]: 'Позиция',
  [opIdiomaCatalogo.DE]: 'Artikel',
  [opIdiomaCatalogo.ES]: 'Ítem',
};

export const ITEMS = {
  [opIdiomaCatalogo.BR]: 'Itens',
  [opIdiomaCatalogo.EN]: 'Items',
  [opIdiomaCatalogo.IT]: 'Articoli',
  [opIdiomaCatalogo.FR]: 'Articles',
  [opIdiomaCatalogo.RU]: 'Позиции',
  [opIdiomaCatalogo.DE]: 'Artikel',
  [opIdiomaCatalogo.ES]: 'Artículos',
};

export const NO_ITEM_ADDED_TO_CART = {
  [opIdiomaCatalogo.BR]: 'Nenhum item adicionado no carrinho',
  [opIdiomaCatalogo.EN]: 'No items added to the cart',
  [opIdiomaCatalogo.IT]: 'Nessun articolo aggiunto al carrello',
  [opIdiomaCatalogo.FR]: 'Aucun article ajouté au panier',
  [opIdiomaCatalogo.RU]: 'В корзину не добавлено ни одного товара',
  [opIdiomaCatalogo.DE]: 'Keine Artikel zum Warenkorb hinzugefügt',
  [opIdiomaCatalogo.ES]: 'Ningún artículo añadido al carrito',
};

export const BROWSE_CATALOG_AND_ADD_PARTS = {
  [opIdiomaCatalogo.BR]:
    'Navegue pelo catálogo e adicione as peças que deseja solicitar.',
  [opIdiomaCatalogo.EN]:
    'Browse the catalog and add the parts you want to request.',
  [opIdiomaCatalogo.IT]:
    'Sfoglia il catalogo e aggiungi i pezzi che desideri richiedere.',
  [opIdiomaCatalogo.FR]:
    'Parcourez le catalogue et ajoutez les pièces que vous souhaitez demander.',
  [opIdiomaCatalogo.RU]:
    'Просмотрите каталог и добавьте детали, которые хотите запросить.',
  [opIdiomaCatalogo.DE]:
    'Durchsuchen Sie den Katalog und fügen Sie die Teile hinzu, die Sie anfragen möchten.',
  [opIdiomaCatalogo.ES]:
    'Navegue por el catálogo y agregue las piezas que desea solicitar.',
};

export const BACK_TO_CATALOG = {
  [opIdiomaCatalogo.BR]: 'Voltar ao catálogo',
  [opIdiomaCatalogo.EN]: 'Back to catalog',
  [opIdiomaCatalogo.IT]: 'Torna al catalogo',
  [opIdiomaCatalogo.FR]: 'Retour au catalogue',
  [opIdiomaCatalogo.RU]: 'Вернуться к каталогу',
  [opIdiomaCatalogo.DE]: 'Zurück zum Katalog',
  [opIdiomaCatalogo.ES]: 'Volver al catálogo',
};

export const MODEL = {
  [opIdiomaCatalogo.BR]: 'Modelo',
  [opIdiomaCatalogo.EN]: 'Model',
  [opIdiomaCatalogo.IT]: 'Modello',
  [opIdiomaCatalogo.FR]: 'Modèle',
  [opIdiomaCatalogo.RU]: 'Модель',
  [opIdiomaCatalogo.DE]: 'Modell',
  [opIdiomaCatalogo.ES]: 'Modelo',
};

export const MANUFACTURER = {
  [opIdiomaCatalogo.BR]: 'Fabricante',
  [opIdiomaCatalogo.EN]: 'Manufacturer',
  [opIdiomaCatalogo.IT]: 'Produttore',
  [opIdiomaCatalogo.FR]: 'Fabricant',
  [opIdiomaCatalogo.RU]: 'Производитель',
  [opIdiomaCatalogo.DE]: 'Hersteller',
  [opIdiomaCatalogo.ES]: 'Fabricante',
};

export const OTHER_INFORMATION = {
  [opIdiomaCatalogo.BR]: 'Outras informações',
  [opIdiomaCatalogo.EN]: 'Other information',
  [opIdiomaCatalogo.IT]: 'Altre informazioni',
  [opIdiomaCatalogo.FR]: 'Autres informations',
  [opIdiomaCatalogo.RU]: 'Другая информация',
  [opIdiomaCatalogo.DE]: 'Weitere Informationen',
  [opIdiomaCatalogo.ES]: 'Otra información',
};

export const REQUESTER = {
  [opIdiomaCatalogo.BR]: 'Solicitante',
  [opIdiomaCatalogo.EN]: 'Requester',
  [opIdiomaCatalogo.IT]: 'Richiedente',
  [opIdiomaCatalogo.FR]: 'Demandeur',
  [opIdiomaCatalogo.RU]: 'Заявитель',
  [opIdiomaCatalogo.DE]: 'Antragsteller',
  [opIdiomaCatalogo.ES]: 'Solicitante',
};

export const EXPORT_SHOPPING_LIST = {
  [opIdiomaCatalogo.BR]: 'Exportar lista de compras',
  [opIdiomaCatalogo.EN]: 'Export shopping list',
  [opIdiomaCatalogo.IT]: 'Esporta lista acquisti',
  [opIdiomaCatalogo.FR]: 'Exporter la liste d’achats',
  [opIdiomaCatalogo.RU]: 'Экспортировать список покупок',
  [opIdiomaCatalogo.DE]: 'Einkaufsliste exportieren',
  [opIdiomaCatalogo.ES]: 'Exportar lista de compras',
};

export const EXPORT_CSV = {
  [opIdiomaCatalogo.BR]: 'Exportar CSV',
  [opIdiomaCatalogo.EN]: 'Export CSV',
  [opIdiomaCatalogo.IT]: 'Esporta CSV',
  [opIdiomaCatalogo.FR]: 'Exporter CSV',
  [opIdiomaCatalogo.RU]: 'Экспортировать CSV',
  [opIdiomaCatalogo.DE]: 'CSV exportieren',
  [opIdiomaCatalogo.ES]: 'Exportar CSV',
};

export const EXPORT_PDF = {
  [opIdiomaCatalogo.BR]: 'Exportar PDF',
  [opIdiomaCatalogo.EN]: 'Export PDF',
  [opIdiomaCatalogo.IT]: 'Esporta PDF',
  [opIdiomaCatalogo.FR]: 'Exporter PDF',
  [opIdiomaCatalogo.RU]: 'Экспортировать PDF',
  [opIdiomaCatalogo.DE]: 'PDF exportieren',
  [opIdiomaCatalogo.ES]: 'Exportar PDF',
};

export const SEND_EMAIL = {
  [opIdiomaCatalogo.BR]: 'Enviar E-mail',
  [opIdiomaCatalogo.EN]: 'Send Email',
  [opIdiomaCatalogo.IT]: 'Invia e-mail',
  [opIdiomaCatalogo.FR]: 'Envoyer un e-mail',
  [opIdiomaCatalogo.RU]: 'Отправить эл. письмо',
  [opIdiomaCatalogo.DE]: 'E-Mail senden',
  [opIdiomaCatalogo.ES]: 'Enviar correo electrónico',
};

export const REQUEST_PARTS = {
  [opIdiomaCatalogo.BR]: 'Solicitar peças',
  [opIdiomaCatalogo.EN]: 'Request parts',
  [opIdiomaCatalogo.IT]: 'Richiedi pezzi',
  [opIdiomaCatalogo.FR]: 'Demander des pièces',
  [opIdiomaCatalogo.RU]: 'Запросить детали',
  [opIdiomaCatalogo.DE]: 'Teile anfordern',
  [opIdiomaCatalogo.ES]: 'Solicitar piezas',
};

export const REQUEST_QUOTE = {
  [opIdiomaCatalogo.BR]: 'Solicitar Orçamento',
  [opIdiomaCatalogo.EN]: 'Request Quote',
  [opIdiomaCatalogo.IT]: 'Richiedi preventivo',
  [opIdiomaCatalogo.FR]: 'Demander un devis',
  [opIdiomaCatalogo.RU]: 'Запросить предложение',
  [opIdiomaCatalogo.DE]: 'Angebot anfordern',
  [opIdiomaCatalogo.ES]: 'Solicitar cotización',
};

export const PARTS_REQUEST_SUCCESSFULLY_CREATED = {
  [opIdiomaCatalogo.BR]: 'Solicitação de peças realizada com sucesso',
  [opIdiomaCatalogo.EN]: 'Parts request successfully created',
  [opIdiomaCatalogo.IT]: 'Richiesta pezzi creata con successo',
  [opIdiomaCatalogo.FR]: 'Demande de pièces créée avec succès',
  [opIdiomaCatalogo.RU]: 'Запрос на детали успешно создан',
  [opIdiomaCatalogo.DE]: 'Teileanfrage erfolgreich erstellt',
  [opIdiomaCatalogo.ES]: 'Solicitud de piezas creada con éxito',
};

export const BACK_TO_HOME = {
  [opIdiomaCatalogo.BR]: 'Voltar para a home',
  [opIdiomaCatalogo.EN]: 'Back to home',
  [opIdiomaCatalogo.IT]: 'Torna alla home',
  [opIdiomaCatalogo.FR]: 'Retour à l’accueil',
  [opIdiomaCatalogo.RU]: 'Вернуться на главную',
  [opIdiomaCatalogo.DE]: 'Zurück zur Startseite',
  [opIdiomaCatalogo.ES]: 'Volver al inicio',
};

export const USER_PROFILE = {
  [opIdiomaCatalogo.BR]: 'Perfil do usuário',
  [opIdiomaCatalogo.EN]: 'User Profile',
  [opIdiomaCatalogo.IT]: 'Profilo utente',
  [opIdiomaCatalogo.FR]: 'Profil utilisateur',
  [opIdiomaCatalogo.RU]: 'Профиль пользователя',
  [opIdiomaCatalogo.DE]: 'Benutzerprofil',
  [opIdiomaCatalogo.ES]: 'Perfil de usuario',
};

export const LOGIN = {
  [opIdiomaCatalogo.BR]: 'Login',
  [opIdiomaCatalogo.EN]: 'Login',
  [opIdiomaCatalogo.IT]: 'Accesso',
  [opIdiomaCatalogo.FR]: 'Connexion',
  [opIdiomaCatalogo.RU]: 'Логин',
  [opIdiomaCatalogo.DE]: 'Login',
  [opIdiomaCatalogo.ES]: 'Inicio de sesión',
};

export const NAME = {
  [opIdiomaCatalogo.BR]: 'Nome',
  [opIdiomaCatalogo.EN]: 'Name',
  [opIdiomaCatalogo.IT]: 'Nome',
  [opIdiomaCatalogo.FR]: 'Nom',
  [opIdiomaCatalogo.RU]: 'Имя',
  [opIdiomaCatalogo.DE]: 'Name',
  [opIdiomaCatalogo.ES]: 'Nombre',
};

export const EMAIL = {
  [opIdiomaCatalogo.BR]: 'E-mail',
  [opIdiomaCatalogo.EN]: 'Email',
  [opIdiomaCatalogo.IT]: 'E-mail',
  [opIdiomaCatalogo.FR]: 'E-mail',
  [opIdiomaCatalogo.RU]: 'Эл. почта',
  [opIdiomaCatalogo.DE]: 'E-Mail',
  [opIdiomaCatalogo.ES]: 'Correo electrónico',
};

export const DOCUMENT = {
  [opIdiomaCatalogo.BR]: 'Documento',
  [opIdiomaCatalogo.EN]: 'Document',
  [opIdiomaCatalogo.IT]: 'Documento',
  [opIdiomaCatalogo.FR]: 'Document',
  [opIdiomaCatalogo.RU]: 'Документ',
  [opIdiomaCatalogo.DE]: 'Dokument',
  [opIdiomaCatalogo.ES]: 'Documento',
};

export const DOCUMENT_NUMBER = {
  [opIdiomaCatalogo.BR]: 'Número Documento',
  [opIdiomaCatalogo.EN]: 'Document Number',
  [opIdiomaCatalogo.IT]: 'Numero documento',
  [opIdiomaCatalogo.FR]: 'Numéro de document',
  [opIdiomaCatalogo.RU]: 'Номер документа',
  [opIdiomaCatalogo.DE]: 'Dokumentnummer',
  [opIdiomaCatalogo.ES]: 'Número de documento',
};

export const ADDITIONAL_INFORMATION = {
  [opIdiomaCatalogo.BR]: 'Informações Complementares',
  [opIdiomaCatalogo.EN]: 'Additional Information',
  [opIdiomaCatalogo.IT]: 'Informazioni complementari',
  [opIdiomaCatalogo.FR]: 'Informations complémentaires',
  [opIdiomaCatalogo.RU]: 'Дополнительная информация',
  [opIdiomaCatalogo.DE]: 'Zusätzliche Informationen',
  [opIdiomaCatalogo.ES]: 'Información complementaria',
};

export const CANCEL = {
  [opIdiomaCatalogo.BR]: 'Cancelar',
  [opIdiomaCatalogo.EN]: 'Cancel',
  [opIdiomaCatalogo.IT]: 'Annulla',
  [opIdiomaCatalogo.FR]: 'Annuler',
  [opIdiomaCatalogo.RU]: 'Отмена',
  [opIdiomaCatalogo.DE]: 'Abbrechen',
  [opIdiomaCatalogo.ES]: 'Cancelar',
};

export const CONFIRM = {
  [opIdiomaCatalogo.BR]: 'Confirmar',
  [opIdiomaCatalogo.EN]: 'Confirm',
  [opIdiomaCatalogo.IT]: 'Conferma',
  [opIdiomaCatalogo.FR]: 'Confirmer',
  [opIdiomaCatalogo.RU]: 'Подтвердить',
  [opIdiomaCatalogo.DE]: 'Bestätigen',
  [opIdiomaCatalogo.ES]: 'Confirmar',
};

export const MY_PICKUPS = {
  [opIdiomaCatalogo.BR]: 'Minhas retiradas',
  [opIdiomaCatalogo.EN]: 'My Pickups',
  [opIdiomaCatalogo.IT]: 'I miei ritiri',
  [opIdiomaCatalogo.FR]: 'Mes retraits',
  [opIdiomaCatalogo.RU]: 'Мои получения',
  [opIdiomaCatalogo.DE]: 'Meine Abholungen',
  [opIdiomaCatalogo.ES]: 'Mis retiros',
};

export const REQUESTED = {
  [opIdiomaCatalogo.BR]: 'Solicitada(s)',
  [opIdiomaCatalogo.EN]: 'Requested',
  [opIdiomaCatalogo.IT]: 'Richiesta/e',
  [opIdiomaCatalogo.FR]: 'Demandée(s)',
  [opIdiomaCatalogo.RU]: 'Запрошено',
  [opIdiomaCatalogo.DE]: 'Angefordert',
  [opIdiomaCatalogo.ES]: 'Solicitada(s)',
};

export const CANCELED = {
  [opIdiomaCatalogo.BR]: 'Cancelada(s)',
  [opIdiomaCatalogo.EN]: 'Canceled',
  [opIdiomaCatalogo.IT]: 'Annullata/e',
  [opIdiomaCatalogo.FR]: 'Annulée(s)',
  [opIdiomaCatalogo.RU]: 'Отменено',
  [opIdiomaCatalogo.DE]: 'Storniert',
  [opIdiomaCatalogo.ES]: 'Cancelada(s)',
};

export const EXPORT_DATA = {
  [opIdiomaCatalogo.BR]: 'Exportar dados',
  [opIdiomaCatalogo.EN]: 'Export data',
  [opIdiomaCatalogo.IT]: 'Esporta dati',
  [opIdiomaCatalogo.FR]: 'Exporter les données',
  [opIdiomaCatalogo.RU]: 'Экспортировать данные',
  [opIdiomaCatalogo.DE]: 'Daten exportieren',
  [opIdiomaCatalogo.ES]: 'Exportar datos',
};

export const PRINT_DATA = {
  [opIdiomaCatalogo.BR]: 'Imprimir dados',
  [opIdiomaCatalogo.EN]: 'Print data',
  [opIdiomaCatalogo.IT]: 'Stampa dati',
  [opIdiomaCatalogo.FR]: 'Imprimer les données',
  [opIdiomaCatalogo.RU]: 'Печать данных',
  [opIdiomaCatalogo.DE]: 'Daten drucken',
  [opIdiomaCatalogo.ES]: 'Imprimir datos',
};

export const SELECT_TO_SEARCH_PICKUP_STATUS = {
  [opIdiomaCatalogo.BR]: 'Selecione para pesquisar a situação da retirada',
  [opIdiomaCatalogo.EN]: 'Select to search the pickup status',
  [opIdiomaCatalogo.IT]: 'Seleziona per cercare lo stato del ritiro',
  [opIdiomaCatalogo.FR]: 'Sélectionnez pour rechercher le statut du retrait',
  [opIdiomaCatalogo.RU]: 'Выберите, чтобы найти статус получения',
  [opIdiomaCatalogo.DE]: 'Auswählen, um den Abholstatus zu suchen',
  [opIdiomaCatalogo.ES]: 'Seleccione para buscar el estado del retiro',
};

export const EMAIL_SENDING = {
  [opIdiomaCatalogo.BR]: 'Envio de e-mail',
  [opIdiomaCatalogo.EN]: 'Email sending',
  [opIdiomaCatalogo.IT]: 'Invio di e-mail',
  [opIdiomaCatalogo.FR]: 'Envoi d’e-mail',
  [opIdiomaCatalogo.RU]: 'Отправка электронной почты',
  [opIdiomaCatalogo.DE]: 'E-Mail-Versand',
  [opIdiomaCatalogo.ES]: 'Envío de correo electrónico',
};

export const YOUR_NAME = {
  [opIdiomaCatalogo.BR]: 'Seu nome',
  [opIdiomaCatalogo.EN]: 'Your name',
  [opIdiomaCatalogo.IT]: 'Il tuo nome',
  [opIdiomaCatalogo.FR]: 'Votre nom',
  [opIdiomaCatalogo.RU]: 'Ваше имя',
  [opIdiomaCatalogo.DE]: 'Ihr Name',
  [opIdiomaCatalogo.ES]: 'Su nombre',
};

export const YOUR_PHONE = {
  [opIdiomaCatalogo.BR]: 'Seu telefone',
  [opIdiomaCatalogo.EN]: 'Your phone',
  [opIdiomaCatalogo.IT]: 'Il tuo telefono',
  [opIdiomaCatalogo.FR]: 'Votre téléphone',
  [opIdiomaCatalogo.RU]: 'Ваш телефон',
  [opIdiomaCatalogo.DE]: 'Ihre Telefonnummer',
  [opIdiomaCatalogo.ES]: 'Su teléfono',
};

export const YOUR_PERSONAL_DOCUMENT = {
  [opIdiomaCatalogo.BR]: 'Seu CPF',
  [opIdiomaCatalogo.EN]: 'Your personal ID',
  [opIdiomaCatalogo.IT]: 'Il tuo documento personale',
  [opIdiomaCatalogo.FR]: 'Votre document d’identité',
  [opIdiomaCatalogo.RU]: 'Ваш документ, удостоверяющий личность',
  [opIdiomaCatalogo.DE]: 'Ihr Ausweisdokument',
  [opIdiomaCatalogo.ES]: 'Su documento de identidad',
};

export const YOUR_EMAIL = {
  [opIdiomaCatalogo.BR]: 'Seu e-mail',
  [opIdiomaCatalogo.EN]: 'Your email',
  [opIdiomaCatalogo.IT]: 'La tua e-mail',
  [opIdiomaCatalogo.FR]: 'Votre e-mail',
  [opIdiomaCatalogo.RU]: 'Ваш e-mail',
  [opIdiomaCatalogo.DE]: 'Ihre E-Mail',
  [opIdiomaCatalogo.ES]: 'Su correo electrónico',
};

export const YOUR_COMPANY = {
  [opIdiomaCatalogo.BR]: 'Sua empresa',
  [opIdiomaCatalogo.EN]: 'Your company',
  [opIdiomaCatalogo.IT]: 'La tua azienda',
  [opIdiomaCatalogo.FR]: 'Votre entreprise',
  [opIdiomaCatalogo.RU]: 'Ваша компания',
  [opIdiomaCatalogo.DE]: 'Ihr Unternehmen',
  [opIdiomaCatalogo.ES]: 'Su empresa',
};

export const YOUR_COMPANY_DOCUMENT = {
  [opIdiomaCatalogo.BR]: 'CNPJ da sua empresa',
  [opIdiomaCatalogo.EN]: 'Your company’s registration number',
  [opIdiomaCatalogo.IT]: 'Numero di registrazione della tua azienda',
  [opIdiomaCatalogo.FR]: 'Numéro d’immatriculation de votre entreprise',
  [opIdiomaCatalogo.RU]: 'Регистрационный номер вашей компании',
  [opIdiomaCatalogo.DE]: 'Registrierungsnummer Ihres Unternehmens',
  [opIdiomaCatalogo.ES]: 'Número de registro de su empresa',
};

export const YOUR_MESSAGE = {
  [opIdiomaCatalogo.BR]: 'Sua mensagem',
  [opIdiomaCatalogo.EN]: 'Your message',
  [opIdiomaCatalogo.IT]: 'Il tuo messaggio',
  [opIdiomaCatalogo.FR]: 'Votre message',
  [opIdiomaCatalogo.RU]: 'Ваше сообщение',
  [opIdiomaCatalogo.DE]: 'Ihre Nachricht',
  [opIdiomaCatalogo.ES]: 'Su mensaje',
};

export const SEND = {
  [opIdiomaCatalogo.BR]: 'Enviar',
  [opIdiomaCatalogo.EN]: 'Send',
  [opIdiomaCatalogo.IT]: 'Invia',
  [opIdiomaCatalogo.FR]: 'Envoyer',
  [opIdiomaCatalogo.RU]: 'Отправить',
  [opIdiomaCatalogo.DE]: 'Senden',
  [opIdiomaCatalogo.ES]: 'Enviar',
};

export const YOUR_CITY = {
  [opIdiomaCatalogo.BR]: 'Sua cidade',
  [opIdiomaCatalogo.EN]: 'Your city',
  [opIdiomaCatalogo.IT]: 'La tua città',
  [opIdiomaCatalogo.FR]: 'Votre ville',
  [opIdiomaCatalogo.RU]: 'Ваш город',
  [opIdiomaCatalogo.DE]: 'Ihre Stadt',
  [opIdiomaCatalogo.ES]: 'Su ciudad',
};

export const YOUR_STATE = {
  [opIdiomaCatalogo.BR]: 'Seu estado',
  [opIdiomaCatalogo.EN]: 'Your state',
  [opIdiomaCatalogo.IT]: 'Il tuo stato',
  [opIdiomaCatalogo.FR]: 'Votre État',
  [opIdiomaCatalogo.RU]: 'Ваш штат/регион',
  [opIdiomaCatalogo.DE]: 'Ihr Bundesland',
  [opIdiomaCatalogo.ES]: 'Su estado',
};

export const YOUR_REGION = {
  [opIdiomaCatalogo.BR]: 'Sua região',
  [opIdiomaCatalogo.EN]: 'Your region',
  [opIdiomaCatalogo.IT]: 'La tua regione',
  [opIdiomaCatalogo.FR]: 'Votre région',
  [opIdiomaCatalogo.RU]: 'Ваш регион',
  [opIdiomaCatalogo.DE]: 'Ihre Region',
  [opIdiomaCatalogo.ES]: 'Su región',
};

export const RECIPIENT = {
  [opIdiomaCatalogo.BR]: 'Destinatário',
  [opIdiomaCatalogo.EN]: 'Recipient',
  [opIdiomaCatalogo.IT]: 'Destinatario',
  [opIdiomaCatalogo.FR]: 'Destinataire',
  [opIdiomaCatalogo.RU]: 'Получатель',
  [opIdiomaCatalogo.DE]: 'Empfänger',
  [opIdiomaCatalogo.ES]: 'Destinatario',
};

export const TO = {
  [opIdiomaCatalogo.BR]: 'Para',
  [opIdiomaCatalogo.EN]: 'To',
  [opIdiomaCatalogo.IT]: 'A',
  [opIdiomaCatalogo.FR]: 'À',
  [opIdiomaCatalogo.RU]: 'Кому',
  [opIdiomaCatalogo.DE]: 'An',
  [opIdiomaCatalogo.ES]: 'Para',
};

export const ADD = {
  [opIdiomaCatalogo.BR]: 'Adicionar',
  [opIdiomaCatalogo.EN]: 'Add',
  [opIdiomaCatalogo.IT]: 'Aggiungi',
  [opIdiomaCatalogo.FR]: 'Ajouter',
  [opIdiomaCatalogo.RU]: 'Добавить',
  [opIdiomaCatalogo.DE]: 'Hinzufügen',
  [opIdiomaCatalogo.ES]: 'Agregar',
};

export const RECIPIENT_LIST = {
  [opIdiomaCatalogo.BR]: 'Lista de Destinatários',
  [opIdiomaCatalogo.EN]: 'Recipient List',
  [opIdiomaCatalogo.IT]: 'Elenco dei destinatari',
  [opIdiomaCatalogo.FR]: 'Liste des destinataires',
  [opIdiomaCatalogo.RU]: 'Список получателей',
  [opIdiomaCatalogo.DE]: 'Empfängerliste',
  [opIdiomaCatalogo.ES]: 'Lista de destinatarios',
};

export const REMOVE = {
  [opIdiomaCatalogo.BR]: 'Remover',
  [opIdiomaCatalogo.EN]: 'Remove',
  [opIdiomaCatalogo.IT]: 'Rimuovi',
  [opIdiomaCatalogo.FR]: 'Supprimer',
  [opIdiomaCatalogo.RU]: 'Удалить',
  [opIdiomaCatalogo.DE]: 'Entfernen',
  [opIdiomaCatalogo.ES]: 'Eliminar',
};
